var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './style.css';
import React from 'react';
import { calculateShowLeft } from '../utils';
import { ColorSelector } from './color-selector';
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.sel = '';
        _this.getColor = function () {
            var _a = _this.props, editor = _a.editor, name = _a.name, getValue = _a.getValue, defaultColor = _a.defaultColor;
            var attrs = editor.getFormat()[name];
            return Boolean(attrs) && attrs && attrs.color ? getValue(attrs) : defaultColor;
        };
        _this.updateColor = function () {
            var selection = _this.props.editor.getSelection();
            if (selection && _this.sel !== JSON.stringify(selection)) {
                _this.sel = JSON.stringify(selection);
                var color = _this.getColor();
                if (color === _this.props.defaultColor)
                    return;
                _this.setState({ color: color });
                _this.setIconColor(color);
            }
        };
        _this.listenClose = function () { return document.addEventListener('mousedown', _this.judge); };
        _this.unListenClose = function () { return document.removeEventListener('mousedown', _this.judge); };
        _this.judge = function (e) {
            var target = e.target;
            if (_this.$btn && _this.$btn.contains(target))
                return;
            if (!_this.picker)
                return _this.hide();
            if (!_this.picker.contains(target)) {
                _this.hide();
            }
            else if (_this.picker.contains(target) && !target.closest('input')) {
                requestAnimationFrame(function () { return _this.props.editor.focus(); });
            }
        };
        _this.changeColor = function (_color) {
            var _a;
            var _b = _this.props, editor = _b.editor, getAttrs = _b.getAttrs, name = _b.name, defaultColor = _b.defaultColor;
            var isInput = document.activeElement ? document.activeElement.tagName === 'INPUT' : false;
            var attrs = _color ? getAttrs(_color) : false;
            editor.setFormat((_a = {}, _a[name] = attrs, _a), { focus: !isInput });
            var resultColor = _color ? _color : defaultColor;
            _this.setState({ color: resultColor }, function () { return _this.setIconColor(resultColor); });
            _this.hide();
        };
        _this.setIconColor = function (color) {
            var mountDOM = _this.props.mountDOM;
            if (mountDOM && mountDOM.querySelector('svg')) {
                var paths = mountDOM.querySelectorAll('path');
                [].slice.call(paths).forEach(function (path) {
                    if (path.getAttribute('color-line')) {
                        path.setAttribute('stroke', color);
                    }
                });
            }
        };
        _this.hide = function () { return _this.setState({ open: false }, _this.unListenClose); };
        _this.open = function () {
            _this.fixPos();
            _this.updateColor();
            _this.changeColor(_this.state.color);
            _this.setState({ open: true }, _this.listenClose);
        };
        _this.toggleVisible = function () { return (_this.state.open ? _this.hide() : _this.open()); };
        var color = _this.getColor();
        _this.state = {
            color: color,
            open: false,
            marginLeft: 0,
        };
        _this.$btn = _this.props.mountDOM.querySelector('.syl-toolbar-button');
        return _this;
    }
    ColorPicker.prototype.fixPos = function () {
        var mountDOM = this.props.mountDOM;
        if (!mountDOM || !this.picker || !this.picker.parentElement)
            return;
        this.setState({ marginLeft: calculateShowLeft(this.picker, mountDOM) });
    };
    ColorPicker.prototype.componentDidMount = function () {
        this.updateColor();
        this.$btn && this.$btn.addEventListener('click', this.toggleVisible);
    };
    ColorPicker.prototype.componentWillUnmount = function () {
        this.$btn && this.$btn.removeEventListener('click', this.toggleVisible);
    };
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.state, open = _a.open, color = _a.color, marginLeft = _a.marginLeft;
        var _b = this.props, name = _b.name, defaultColor = _b.defaultColor;
        return (React.createElement("div", { className: "syl-color-picker-container", "data-syl-toolbar": "true", ref: function (el) { return el && (_this.picker = el); }, style: __assign({ visibility: open ? 'visible' : 'hidden' }, (marginLeft ? { marginLeft: marginLeft } : {})) },
            React.createElement(ColorSelector, { name: name, selectedColor: color, onClick: this.changeColor, resetColor: defaultColor })));
    };
    return ColorPicker;
}(React.Component));
export { ColorPicker };
//# sourceMappingURL=index.js.map